import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";

const FormAutocomplete = ({
  name,
  control,
  label,
  options,
  onChange,
  defaultValue,
  formLabel,
  width,
  disabled = false,
  error,
  margin,
  onClear, // Nueva prop opcional
}) => {
  const StyledAutocomplete = styled(Autocomplete)(() => ({
    margin: margin ? margin : "10px 5px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      height: "40px",
      padding: "0 10px",
    },
  }));

  return (
    <Box sx={{ minWidth: 120 }}>
      <p className="select-form-label">{label}</p>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || null}
        render={({ field }) => (
          <StyledAutocomplete
            {...field}
            options={options}
            disabled={disabled}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            onChange={(e, value) => {
              field.onChange(value || null);
              onChange && onChange(value || null);
              if (value === null && onClear) {
                onClear(); // Llama a onClear cuando el usuario limpia la selección
              }
            }}
            clearOnEscape
            renderInput={(params) => (
              <TextField
                {...params}
                label={formLabel}
                error={Boolean(error)}
                helperText={error ? error.message : null}
                variant="outlined"
              />
            )}
          />
        )}
      />
    </Box>
  );
};

export default FormAutocomplete;
